import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../../language/vn';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {first} from 'rxjs/operators';
import {validateEmpty} from '../../../../global/custom-validate';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {UploadFileComponent} from '../../../ui/upload/uploadfile.component';
import {Subject} from 'rxjs';
import {DatePipe} from '@angular/common';
import {CommandUtil} from '../../../../global/commandutil';
import {LoaiVanBan} from '../../../../models/danhmuc/loaivanban';
import {LinhVucVanBan} from '../../../../models/danhmuc/linhvucvanban';
import {DoMat} from '../../../../models/danhmuc/domat';
import {DoKhan} from '../../../../models/danhmuc/dokhan';
import {GroupOTherComponent} from '../../groupother/groupother.component';
import {VanBanDenService} from '../../../../service/vanbanden/service-vanbanden';
import {VanBanDenFileService} from '../../../../service/vanbanden/service-vanbandenfile';
import {LoaiVanBanService} from '../../../../service/danhmuc/service-loaivanban';
import {LinhVucVanBanService} from '../../../../service/danhmuc/service-linhvucvanban';
import {DoMatService} from '../../../../service/danhmuc/service-domat';
import {DoKhanService} from '../../../../service/danhmuc/service-dokhan';
import {VanBanDenFile} from '../../../../models/vanbanden/vanbandenfile';
import {Sessioncommand} from '../../../../global/sessioncommand';
import {DMNguon} from '../../../../models/danhmuc/dmnguon';
import {DMNguonService} from '../../../../service/danhmuc/service-dmnguon';

@Component({
  templateUrl: './edit.component.html'

})
export class EditVanBanDenComponent implements OnInit, AfterViewInit {

  @ViewChild(UploadFileComponent)
  public uploadFileComponent: UploadFileComponent;
  public language = language;
  public frmGroup: FormGroup;
  public id: number=0;
  public isEdit: boolean = false;
  public isRefresh: boolean = false;
  public submitValidate = false;
  public uploadUrl: String;
  public deleteUrl: String;
  public fileLists: Object[];
  public dataLoaiVanBan: LoaiVanBan[];
  public dataLinhVuc: LinhVucVanBan[];
  private dataDMNguon: DMNguon[];
  public dataDoMat: DoMat[];
  public dataDoKhan: DoKhan[];
  public dateNgayKy: Date= new Date();
  public dateNgayNhan: Date= new Date();
  public dateNgayVaoSo: Date= new Date();
  public defaultValue: string[]=["-1"];
  @ViewChild("selectGroup")
  public selectGroup: GroupOTherComponent;
  public  onClose: Subject<boolean>;
  constructor(  public vanBanDenService: VanBanDenService,
                public formBuilder: FormBuilder,
                public toastr: ToastrService,
                public bsModalService: BsModalService,
                public vanBanDenFileService: VanBanDenFileService,
                public loaiVanBanService: LoaiVanBanService,
                public linhVucVanBanService: LinhVucVanBanService,
                public doMatService: DoMatService,
                public doKhanService: DoKhanService,
                public datepipe: DatePipe,
                public _bsModalRef: BsModalRef,
                public commandUtils: CommandUtil,
                private dmNguonService: DMNguonService
  ) {
  }
  ngAfterViewInit() {

  }
  toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();

  }
  public edit(id: number) {
    this.id=id;
    this.isEdit =(id!=0)? true: false;
    this.vanBanDenService.getById(id).pipe(first())
      .subscribe(x => {
        if(id === 0)
        {
          x.maDoKhan = 1;
          x.maDoMat = 1;
        }
        this.frmGroup.patchValue(x);
        this.defaultValue=[x.maNoiGui.toString()];
        this.dateNgayKy= this.commandUtils.getDate(x.ngayKy);
        this.dateNgayNhan= this.commandUtils.getDate(x.ngayNhan);
        this.dateNgayVaoSo= this.commandUtils.getDate(x.ngayVaoSo);
      });
    let files: VanBanDenFile[];
    this.fileLists =  [];
    this.vanBanDenFileService.findAllByVanBanId(id).subscribe(
      x => {
        files = x;
        for(let i=0; i< files.length; i++)
        {
          this.fileLists.push({ id: files[i].id,
            title: files[i].name ,
            name: files[i].fileKey,
            size: files[i].size,
            fileType: files[i].width,
            folder: files[i].folder });
        }
        this.uploadFileComponent.uploadCommand["files"]= this.fileLists;
      });
  }

  ngOnInit(): void {
    this.onClose = new Subject();
    this.frmGroup = new FormGroup({
      id: new FormControl('0'),
      soVaoSo: new FormControl(),
      soHieuGoc: new FormControl(),
      maLoaiVB: new FormControl(),
      trichYeu: new FormControl(),
      maLinhVuc: new FormControl(),
      maDoMat: new FormControl(),
      maDoKhan: new FormControl(),
      ngayKy: new FormControl(),
      nguoiKy: new FormControl(),
      ngayNhan: new FormControl(),
      ngayVaoSo: new FormControl(),
      ghiChu: new FormControl(),
      nguoiNhapID: new FormControl(),
      maNoiGui: new FormControl(),
      noiLuu: new FormControl()

    });
    this.frmGroup = this.formBuilder.group({
      id:  ['0', Validators.nullValidator],
      soVaoSo: ['' , Validators.compose([validateEmpty]) ],
      soHieuGoc: ['' , Validators.compose([validateEmpty]) ],
      maLoaiVB: ['' , Validators.compose([validateEmpty]) ],
      trichYeu: ['' , Validators.compose([validateEmpty]) ],
      maLinhVuc: ['' , Validators.nullValidator],
      maDoMat: ['1', Validators.nullValidator],
      maDoKhan: ['1', Validators.nullValidator],
      ngayKy: ['' , Validators.compose([validateEmpty]) ],
      nguoiKy: ['' , Validators.compose([validateEmpty]) ],
      ngayNhan: ['' , Validators.compose([validateEmpty]) ],
      ngayVaoSo: ['' , Validators.compose([validateEmpty]) ],
      ghiChu: ['', Validators.nullValidator],
      nguoiNhapID:  ['0', Validators.nullValidator],
      maNoiGui:  ['0', Validators.nullValidator],
      noiLuu: ['', Validators.nullValidator]
    });
    this.uploadUrl= this.vanBanDenFileService.urlUpload;
    this.deleteUrl= this.vanBanDenFileService.urlDelete;
    this.loaiVanBanService.getAll().subscribe(data => this.dataLoaiVanBan = data);
    this.linhVucVanBanService.getAll().subscribe(data => this.dataLinhVuc = data);
    this.doMatService.getAll().subscribe(data => this.dataDoMat = data);
    this.doKhanService.getAll().subscribe(data => this.dataDoKhan = data);
    this.dmNguonService.getAll().subscribe(data => this.dataDMNguon = data);
  }
  get f() { return this.frmGroup.controls; }

  createItem ()
  {
    this.frmGroup.value.ngayKy = this.datepipe.transform(Date.parse(this.frmGroup.value.ngayKy), 'dd/MM/yyyy');;
    this.frmGroup.value.ngayNhan = this.datepipe.transform(Date.parse(this.frmGroup.value.ngayNhan), 'dd/MM/yyyy');;
    this.frmGroup.value.ngayVaoSo = this.datepipe.transform(Date.parse(this.frmGroup.value.ngayVaoSo), 'dd/MM/yyyy');;
    this.frmGroup.value.nguoiNhapID = Number(sessionStorage.getItem("staffId"));
    this.frmGroup.value.maNoiGui= Number(this.selectGroup.selectTree.value);
    this.vanBanDenService.add(this.frmGroup.value).subscribe(
      {    next: (data) => {
          this.uploadFileComponent.id = data.id;
          this.uploadFileComponent.uploadCommand.upload( this.uploadFileComponent.uploadCommand.getFilesData());
          this.toastr.success(language.add_success_record, language.message);
          Sessioncommand.notification = true;
          Sessioncommand.vanBanDenStatus = 0;
          this.onCancel();
        },
        error: error => {
          this.toastr.error(language.error, language.message);
        }
      });
  }
  public updateItem()
  {
    this.frmGroup.value.ngayKy = this.datepipe.transform(this.dateNgayKy, 'dd/MM/yyyy');;
    this.frmGroup.value.ngayNhan = this.datepipe.transform(this.dateNgayNhan, 'dd/MM/yyyy');;
    this.frmGroup.value.ngayVaoSo = this.datepipe.transform(this.dateNgayVaoSo, 'dd/MM/yyyy');;
    this.frmGroup.value.maNguoiChuTri = Number(sessionStorage.getItem("staffId"));
    this.frmGroup.value.maNoiGui= Number(this.selectGroup.selectTree.value);
    this.vanBanDenService.update(this.frmGroup.value).subscribe(
      {    next: (data) => {
        this.uploadFileComponent.id = data.id;
        this.uploadFileComponent.uploadCommand.upload( this.uploadFileComponent.uploadCommand.getFilesData());
        this.toastr.success(language.update_success_record, language.message);
          Sessioncommand.vanBanDenStatus = 0;
          this.onCancel();
      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });
  }
  public onSubmit()
  {
    this.submitValidate = true;
    if(this.frmGroup.invalid)
      return;
    if(this.isEdit)
      this.updateItem();
    else
      this.createItem();


  }
  public onSave(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }

}

